import { useQuery } from "@tanstack/react-query";
import { ContentFormatType } from "../types";

import { GET } from "../services/requests";

export const useSortedContentFormats = () => {
  const query = useQuery<ContentFormatType[], Error, ContentFormatType[]>({
    // @ts-ignore
    queryKey: ["CONTENT-FORMATS-ORDERED"],
    queryFn: async () => {
      const data = await GET("/content-formats/landing-page-order");
      return data;
    },
    staleTime: 5 * (60 * 1000), 
    cacheTime: 7 * (60 * 1000),
  });

  return { ...query };
};
